export const RED_COLOR = "#dc3545";
export const ORANGE_COLOR = "#FFB68F";
export const DARK_SALMON_COLOR = "#f78782";
export const WHITE_COLOR = "#ffffff";
export const GREY_COLOR = "#9aa5b1";
export const LIGHT_BLUE = "#178bf0";
export const DARK_BLUE = "#47a3f3";
export const GREEN_COLOR = "#b8f0bf";

export const DARKER_SALMON_COLOR = "#ff6b1c";
export const DARKER_DARK_SALMON_COLOR = "#f12d22";
export const DARKER_GREY_COLOR = "#647282";
export const DARKER_LIGHT_BLUE = "#0a5699";
export const DARKER_DARK_BLUE = "#0d71c9";
export const DARKER_WHITE_COLOR = "#cccccc";
